import { useEffect, useState, useRef } from "react";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
import { trackPerformance } from "@/utils/telemetry";
import { DynamicLogo } from "@/components/layout/DynamicLogo";

export const LoadingScreen = () => {
  const [progress, setProgress] = useState(10);
  const [isError, setIsError] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const startTime = useRef(performance.now());

  useEffect(() => {
    // Only show the loading screen if loading takes more than 300ms
    const visibilityTimer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearInterval(timer);
          return 90;
        }
        return prev + Math.random() * 15;
      });
    }, 400);

    const safetyTimeout = setTimeout(() => {
      setIsError(true);
      trackPerformance({
        lcp: null,
        cls: null,
        loadTime: performance.now() - startTime.current,
        slug: window.location.pathname,
        lang: 'unknown',
        timestamp: new Date().toISOString(),
        status: 'timeout',
        errorReason: 'LoadingScreen: 15s safety timeout reached'
      });
    }, 15000);

    return () => {
      clearTimeout(visibilityTimer);
      clearInterval(timer);
      clearTimeout(safetyTimeout);
    };
  }, []);


  if (!isVisible) return null;


  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background">
      <div className="relative flex flex-col items-center space-y-8 animate-in fade-in duration-500">
        <div className="relative">
          <DynamicLogo 
            width={120} 
            height={120} 
            imgClassName="md:w-32 md:h-32"
          />
        </div>
        
        <div className="w-64 space-y-3">
          <Progress value={progress} className="h-1.5" />
          <p className={cn(
            "text-sm font-medium text-center text-muted-foreground transition-all duration-300",
            progress > 0 ? "opacity-100" : "opacity-0"
          )}>
            {isError ? "Cargando componentes... (Esto puede tardar un momento)" : "Iniciando experiencia..."}
          </p>
        </div>

        {isError && (
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 mt-4 text-xs font-medium text-white bg-primary rounded-md hover:bg-primary/90 transition-colors"
          >
            Reintentar carga
          </button>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
